import type { UserPermission } from '@contracts/users/UserPermission';
import { UsersClient } from '@src/manageUsers/services/UsersClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUserUpdate = (
  userId: string,
  { onSuccess }: { onSuccess: () => void },
) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: (data: {
      name: string;
      extension?: string;
      permissions: Set<UserPermission>;
    }) => UsersClient.update(userId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['users.find', userId] });
      onSuccess();
    },
  });

  return {
    updateUser: mutate,
    isLoading: isPending,
  };
};
